var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShop = function SvgShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6.5 12.5v7h11v-7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M10.5 15.5h3v4h-3zM5.26 10.802 6.36 7.5h2.05l-.654 3.922a1.29 1.29 0 1 1-2.496-.62ZM7.863 10.865l.56-3.365h2.534l-.31 3.712a1.404 1.404 0 1 1-2.784-.347ZM10.664 11.048 10.96 7.5h2.08l.296 3.548a1.34 1.34 0 1 1-2.672 0ZM13.353 11.212l-.31-3.712h2.533l.561 3.365a1.404 1.404 0 1 1-2.784.347ZM16.244 11.422 15.59 7.5h2.05l1.1 3.302a1.29 1.29 0 1 1-2.496.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.5,
    d: "M7.25 5.25h9.5v.5h-9.5z"
  })));
};
export default SvgShop;